// ---------- Free simple tier (in-page, gated by email) ----------
export const INTERPRET_SIMPLE_REQUEST = 'SUENOS/INTERPRET_SIMPLE_REQUEST';
export const interpretSimpleRequest = (dreamText, email) =>
  ({ type: INTERPRET_SIMPLE_REQUEST, payload: { dream_text: dreamText, email } });

export const INTERPRET_SIMPLE_SUCCESS = 'SUENOS/INTERPRET_SIMPLE_SUCCESS';
export const interpretSimpleSuccess = (reading) =>
  ({ type: INTERPRET_SIMPLE_SUCCESS, payload: { reading } });

export const INTERPRET_SIMPLE_FAILURE = 'SUENOS/INTERPRET_SIMPLE_FAILURE';
export const interpretSimpleFailure = (error) =>
  ({ type: INTERPRET_SIMPLE_FAILURE, payload: { error } });

export const RESET_SIMPLE = 'SUENOS/RESET_SIMPLE';
export const resetSimple = () => ({ type: RESET_SIMPLE });

export const SET_SIMPLE_LIKE_REQUEST = 'SUENOS/SET_SIMPLE_LIKE_REQUEST';
export const setSimpleLikeRequest = (readingId, like) =>
  ({ type: SET_SIMPLE_LIKE_REQUEST, payload: { reading_id: readingId, like } });

export const SET_SIMPLE_LIKE_SUCCESS = 'SUENOS/SET_SIMPLE_LIKE_SUCCESS';
export const setSimpleLikeSuccess = () => ({ type: SET_SIMPLE_LIKE_SUCCESS });

// ---------- Premium reading (paid OR perk SU) ----------
// Both flows enter the same human-review pipeline. The frontend polls
// get_premium_reading after payment / submission to detect PENDING_REVIEW.
export const PREMIUM_REQUEST = 'SUENOS/PREMIUM_REQUEST';
export const premiumRequest = (readingId, email) =>
  ({ type: PREMIUM_REQUEST, payload: { reading_id: readingId, email } });

export const PREMIUM_SUCCESS = 'SUENOS/PREMIUM_SUCCESS';
export const premiumSuccess = (data) => ({ type: PREMIUM_SUCCESS, payload: { data } });

export const PREMIUM_PENDING = 'SUENOS/PREMIUM_PENDING';
export const premiumPending = (etaAt) =>
  ({ type: PREMIUM_PENDING, payload: { etaAt } });

export const PREMIUM_FAILURE = 'SUENOS/PREMIUM_FAILURE';
export const premiumFailure = (error) => ({ type: PREMIUM_FAILURE, payload: { error } });

// ---------- Perk-SU deep reading request ----------
export const REQUEST_DEEP_READING_REQUEST = 'SUENOS/REQUEST_DEEP_READING_REQUEST';
export const requestDeepReadingRequest = (dreamText, context) =>
  ({ type: REQUEST_DEEP_READING_REQUEST, payload: { dream_text: dreamText, context } });

export const REQUEST_DEEP_READING_SUCCESS = 'SUENOS/REQUEST_DEEP_READING_SUCCESS';
export const requestDeepReadingSuccess = (readingId) =>
  ({ type: REQUEST_DEEP_READING_SUCCESS, payload: { readingId } });

export const REQUEST_DEEP_READING_FAILURE = 'SUENOS/REQUEST_DEEP_READING_FAILURE';
export const requestDeepReadingFailure = (error) =>
  ({ type: REQUEST_DEEP_READING_FAILURE, payload: { error } });

// ---------- Anonymous per-reading purchase flow ----------
export const CREATE_PENDING_DEEP_REQUEST = 'SUENOS/CREATE_PENDING_DEEP_REQUEST';
export const createPendingDeepRequest = (email, dreamText, context) =>
  ({ type: CREATE_PENDING_DEEP_REQUEST, payload: { email, dream_text: dreamText, context } });
export const CREATE_PENDING_DEEP_SUCCESS = 'SUENOS/CREATE_PENDING_DEEP_SUCCESS';
export const createPendingDeepSuccess = (readingId) =>
  ({ type: CREATE_PENDING_DEEP_SUCCESS, payload: { readingId } });
export const CREATE_PENDING_DEEP_FAILURE = 'SUENOS/CREATE_PENDING_DEEP_FAILURE';
export const createPendingDeepFailure = (error) =>
  ({ type: CREATE_PENDING_DEEP_FAILURE, payload: error });

export const SUENOS_CHECKOUT_REQUEST = 'SUENOS/CHECKOUT_REQUEST';
export const suenosCheckoutRequest = (email, readingId) =>
  ({ type: SUENOS_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const SUENOS_CHECKOUT_SUCCESS = 'SUENOS/CHECKOUT_SUCCESS';
export const suenosCheckoutSuccess = () => ({ type: SUENOS_CHECKOUT_SUCCESS });
export const SUENOS_CHECKOUT_FAILURE = 'SUENOS/CHECKOUT_FAILURE';
export const suenosCheckoutFailure = (e) => ({ type: SUENOS_CHECKOUT_FAILURE, payload: e });

export const SUENOS_PAYPAL_REQUEST = 'SUENOS/PAYPAL_REQUEST';
export const suenosPaypalOrderRequest = (email, readingId) =>
  ({ type: SUENOS_PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const SUENOS_PAYPAL_SUCCESS = 'SUENOS/PAYPAL_SUCCESS';
export const suenosPaypalOrderSuccess = () => ({ type: SUENOS_PAYPAL_SUCCESS });
export const SUENOS_PAYPAL_FAILURE = 'SUENOS/PAYPAL_FAILURE';
export const suenosPaypalOrderFailure = (e) => ({ type: SUENOS_PAYPAL_FAILURE, payload: e });

export const SUENOS_VERIFY_REQUEST = 'SUENOS/VERIFY_REQUEST';
export const suenosVerifyPurchaseRequest = (sessionId) =>
  ({ type: SUENOS_VERIFY_REQUEST, payload: { session_id: sessionId } });
export const SUENOS_VERIFY_SUCCESS = 'SUENOS/VERIFY_SUCCESS';
export const suenosVerifyPurchaseSuccess = (data) =>
  ({ type: SUENOS_VERIFY_SUCCESS, payload: data });
export const SUENOS_VERIFY_FAILURE = 'SUENOS/VERIFY_FAILURE';
export const suenosVerifyPurchaseFailure = (e) => ({ type: SUENOS_VERIFY_FAILURE, payload: e });

export const SUENOS_VERIFY_PAYPAL_REQUEST = 'SUENOS/VERIFY_PAYPAL_REQUEST';
export const suenosVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: SUENOS_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const SUENOS_VERIFY_PAYPAL_SUCCESS = 'SUENOS/VERIFY_PAYPAL_SUCCESS';
export const suenosVerifyPaypalSuccess = (data) =>
  ({ type: SUENOS_VERIFY_PAYPAL_SUCCESS, payload: data });
export const SUENOS_VERIFY_PAYPAL_FAILURE = 'SUENOS/VERIFY_PAYPAL_FAILURE';
export const suenosVerifyPaypalFailure = (e) => ({ type: SUENOS_VERIFY_PAYPAL_FAILURE, payload: e });
